import { Badge } from "@/shared/ui";
import type { Timesheet, TimesheetStatus } from "@/features/timesheets/types";

interface Props {
  status: TimesheetStatus;
  reviewedBy?: string | null;
}

export function TimesheetStatusBadge({ status, reviewedBy }: Props) {
  if (status === "PENDING_REVIEW") {
    return (
      <Badge variant="warning" dot>
        Pending review
      </Badge>
    );
  }
  if (status === "APPROVED") {
    return (
      <Badge variant="success" dot>
        {reviewedBy ? "Approved" : "Auto-approved"}
      </Badge>
    );
  }
  return (
    <Badge variant="destructive" dot>
      Disputed
    </Badge>
  );
}

const FLAG_LABELS: Record<keyof Pick<Timesheet, "off_site_checkout" | "no_gps" | "auto_closed" | "manual_by_venue">, string> = {
  off_site_checkout: "Off-site checkout",
  no_gps: "No GPS",
  auto_closed: "Auto-closed",
  manual_by_venue: "Closed by venue",
};

export function TimesheetFlagBadges({ timesheet }: { timesheet: Timesheet }) {
  const flags = (Object.keys(FLAG_LABELS) as Array<keyof typeof FLAG_LABELS>).filter(
    (key) => timesheet[key],
  );
  if (flags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {flags.map((flag) => (
        <Badge key={flag} variant="outline">
          {FLAG_LABELS[flag]}
        </Badge>
      ))}
    </div>
  );
}
